import { render, staticRenderFns } from "./TermoCompromissoAssinaturaBoxComponent.vue?vue&type=template&id=47f8c973&scoped=true&lang=pug"
import script from "./TermoCompromissoAssinaturaBoxComponent.vue?vue&type=script&lang=js"
export * from "./TermoCompromissoAssinaturaBoxComponent.vue?vue&type=script&lang=js"
import style0 from "./TermoCompromissoAssinaturaBoxComponent.vue?vue&type=style&index=0&id=47f8c973&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f8c973",
  null
  
)

export default component.exports